import script from "./MoleculePurchaseLicenseModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculePurchaseLicenseModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculePurchaseLicenseModal.vue?vue&type=style&index=0&id=8037e2f2&lang=css"

const __exports__ = script;

export default __exports__